import { getCookie } from '@ynap/redux-cookies-middleware/src/cookieApi'; //eslint-disable-line monorepo/no-internal-import

import { getLocale, getHeadConfig } from '@ynap/config-state';

export const getAutomaticMarketingConsent = (state) => {
    const { country } = getLocale(state);
    const { flags } = getHeadConfig(state);
    const { disableAutomaticConsentCountryList } = flags || {}

    if (disableAutomaticConsentCountryList) {
        const geoCountry = getCookie('geoIP');
        if (geoCountry) {
            return {
                automaticMarketingConsent: !(disableAutomaticConsentCountryList.includes(geoCountry) && disableAutomaticConsentCountryList.includes(country)),
            };
        }
    }

    return {
        automaticMarketingConsent: true,
    };
};
